<nz-modal [(nzVisible)]="isVisible" [nzTitle]="data?.id ? 'Edit POC' : 'Add a New POC'" [nzMaskClosable]="false"  (nzOnCancel)="handleCancel()" [nzFooter]="modalFooter">
<ng-container *nzModalContent>

       <!-- contact-form.component.html -->
<form nz-form [formGroup]="vendorForm" >
    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Contact Person</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please enter your contact person">
        <input nz-input formControlName="contact_person" placeholder="Enter contact person" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
        <nz-form-label [nzSpan]="7" >Client Phone</nz-form-label>
        <nz-form-control [nzSpan]="17" >
         <nz-input-group   [nzAddOnBefore]="addOnBeforeTemplate">
            <ng-template #addOnBeforeTemplate>

              <nz-select nzShowSearch  formControlName="country_code" class="phone-select" nzPlaceHolder="Code">
             @for (countryCode of countryCodeList; track countryCode.id) {
                <nz-option  [nzValue]="countryCode.id" [nzLabel]="`${countryCode.code} (${countryCode.country_name})` "></nz-option>
              }
              </nz-select>
            </ng-template>
            <input formControlName="phone_number" id="phoneNumber" nz-input placeholder="Enter phone number" />
          </nz-input-group>
         </nz-form-control>
    </nz-form-item>

    <nz-form-item>
  <nz-form-label [nzSpan]="7">Email</nz-form-label>
  <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid email">
    <input nz-input formControlName="email" placeholder="Enter email address" />
  </nz-form-control>
</nz-form-item>


  <nz-form-item>
  <nz-form-label [nzSpan]="7" nzRequired>Designation</nz-form-label>
  <nz-form-control [nzSpan]="17" nzErrorTip="Please enter designation">
    <input nz-input formControlName="designation" placeholder="Enter designation" />
  </nz-form-control>
</nz-form-item>


<!-- <nz-form-item>
  <nz-form-label [nzSpan]="7">LinkedIn Profile</nz-form-label>
  <nz-form-control [nzSpan]="17">
    <input nz-input formControlName="linkedin" placeholder="Enter LinkedIn URL" />
  </nz-form-control>
</nz-form-item> -->

<nz-form-item>
  <nz-form-label [nzSpan]="7">LinkedIn Profile</nz-form-label>
  <nz-form-control [nzSpan]="17" nzErrorTip="Please provide correct URL">
    <nz-input-group nzAddOnBefore="https://">
      <input nz-input formControlName="linkedin" placeholder="Enter LinkedIn URL" />
    </nz-input-group>
  </nz-form-control>
</nz-form-item>




  </form>

</ng-container>


    <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
        <button nz-button nzType="primary" [disabled]="!vendorForm.valid" (click)="save()">{{data?.id ? 'Update' : 'Save'}}</button>
    </ng-template>

</nz-modal>
